import axios from "axios";
import { BACKEND_URL as API_BASE } from "./api";

// Plain axios instance (no auth) for public listing pages
export const BACKEND_URL = API_BASE;
export const publicApi = axios.create({
  baseURL: `${BACKEND_URL}/api/public`,
});

// iter v28 r194 — AnteprimaVetrina passa URL locali statici tipo
// `/landing/vetrina-hero.jpg`. In quei casi (path assoluto o full URL)
// bypassiamo il proxy `/api/public/file` e serviamo direttamente il
// path così le immagini demo si caricano nel mockup landing.
// iter v29 r247 — opzionale `w` per thumbnail server-side (cache LRU).
// Le miniature delle gallery scendono da ~3MB a ~30KB.
// iter v33 r66 — le foto in preview owner-only arrivano gia' come URL
// relativi COMPLETI del tipo `/api/public/file?listing_id=X&path=Y&preview_token=T`.
// In quel caso bypassiamo il wrapping e prependiamo solo BACKEND_URL.
export const publicFileUrl = (listingId, path, w = null) => {
  if (!path) return "";
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  if (path.startsWith("/landing/") || path.startsWith("/static/")) return path;
  if (path.startsWith("/api/")) {
    // Path gia' pronto (es. preview-listing con preview_token embedded).
    const wSuffix = w ? `${path.includes("?") ? "&" : "?"}w=${w}` : "";
    return `${BACKEND_URL}${path}${wSuffix}`;
  }
  const wParam = w ? `&w=${w}` : "";
  return `${BACKEND_URL}/api/public/file?listing_id=${encodeURIComponent(listingId)}&path=${encodeURIComponent(path)}${wParam}`;
};
